import {
  InputGroup,
  NumberInputField,
  useInputGroupState,
} from "@smartsuite/react-ui/lib";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { useRootStore } from "../../../../../../../../../../stores/hooks";
import { useRepeatedSchedule } from "../../repeated-schedule.hook";
import { LIMITS } from "./interval-limits";
import * as S from "./style";

interface RepeatEveryProps {
  isDisabled: boolean;
}

export const RepeatEvery: FC<RepeatEveryProps> = ({ isDisabled }) => {
  const { state, onFocus, onBlur } = useInputGroupState();

  const { scheduleStore } = useRootStore();
  const { getRepeatEvery, setRepeatEvery, getScheduleType } =
    useRepeatedSchedule();

  const [currentValue, setCurrentValue] = useState<number>(() =>
    getRepeatEvery(),
  );

  useEffect(() => {
    setCurrentValue(getRepeatEvery());
  }, [scheduleStore.schedule]);

  return (
    <S.NumberWrapper isDisabled={isDisabled}>
      <InputGroup state={state}>
        <NumberInputField
          disabled={isDisabled}
          placeholder=""
          max={LIMITS[getScheduleType()]?.max}
          min={LIMITS[getScheduleType()]?.min}
          value={String(currentValue)}
          showSymbol={false}
          autoHideNavigation={true}
          onFocus={onFocus}
          onBlur={onBlur}
          onChangeValue={(value) => setRepeatEvery(+value)}
        />
      </InputGroup>
    </S.NumberWrapper>
  );
};
